// extracted by mini-css-extract-plugin
module.exports = {"slider":"styles_slider__S0d2W","snap":"styles_snap__YHjNn","mouseDown":"styles_mouseDown__eGniF"};